import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsBranches from '../../../../../../stores/global-settings-branches';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deleteBuildingOperation = async (
  branchId: number,
  buildingId: number,
  setBuildingId: (buildingId: number | null) => void,
) => {
  try {
    setBuildingId(buildingId);

    const res = await appApi.removeBranchBuilding(branchId, buildingId);
    if (res.data.ok) {
      const branchesData = await appApi.getBranches();
      globalSettingsBranches.branches = branchesData;
      toast.success('המבנה נמחק בהצלחה');
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }
    setBuildingId(null);
  } catch (e) {
    setBuildingId(null);
    console.error(
      `deleteBuildingOperation failed with the branchId: ${branchId}, buildingId: ${buildingId}, and the error: ${e}`,
    );
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
